export default "__VITE_ASSET__CLi2$4rJ__"